export function initialize(appInstance: any) {
  const intl = appInstance.lookup('service:intl');

  // Check for locale in browser environment
  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    let locale = 'en'; // default

    // First, try to detect locale from URL path (e.g., /en, /es)
    const pathname = window.location.pathname;
    const urlLocaleMatch = pathname.match(/^\/(en|es)(?:\/|$)/);

    if (urlLocaleMatch) {
      locale = urlLocaleMatch[1];
    } else {
      // Try localStorage first (preferred method)
      if (window.localStorage) {
        try {
          const stored = window.localStorage.getItem('locale');
          if (stored === 'en' || stored === 'es') {
            locale = stored;
          }
        } catch (e) {
          // localStorage might be disabled, continue to cookie fallback
        }
      }

      // Fall back to locale cookie if localStorage didn't have it
      if (locale === 'en') {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
          const [name, value] = cookie.trim().split('=');
          if (name === 'locale' && (value === 'en' || value === 'es')) {
            locale = value;
            break;
          }
        }
      }
    }

    // Normalize and set locale
    if (locale === 'es' || locale === 'es-AR') {
      intl.setLocale(['es']);
    } else {
      intl.setLocale(['en']);
    }
  } else {
    // Default to English in non-browser environments
    intl.setLocale(['en']);
  }
}

export default {
  name: 'ember-intl',
  initialize
};

